import React from 'react';
import FollowUpAgenciamentoRegistrationPageBase from './FollowUpAgenciamentoRegistrationPageBase';

export default function FollowUpAgenciamentoRegistrationExportAereoPage(props) {
  return (
    <FollowUpAgenciamentoRegistrationPageBase
      {...props}
      urlPosSalvar={(created) => `/exportacao/agenciamento/aereo/follow-up?processo=${created?.numero || ''}`}
      breadcrumbConfig={(t, actionName) => [
        {
          link: { to: '/', name: t('com.muralis.qcx.inicio') },
        },
        {
          link: { to: '/exportacao/agenciamento/aereo', name: 'Exportação Agenciamento Aéreo' },
        },
        {
          link: { to: '/exportacao/agenciamento/aereo/follow-up', name: 'Follow-Up' },
        },
        { text: { name: t('com.muralis.qcx.registro') } },
        { text: { name: actionName } },
      ]}
    />
  );
}
